const users = [
  {
    path: '/user-show',
    name: 'users-show',
    component: () => import('@/pages/users/index.vue'),
    meta: {
      requiresAuth: true,
      layout: 'content',
      action: 'can_see_dashboard',
    },
  },
]

export default users
